<template>
  <div>
    <Modal
    v-model="showPopup"
    title="学习监督"
    :closable="false"
    :mask-closable="false"
    :footer-hide="true"
  >
    <div v-if="superviseUrl" class="modal-content">
      <!-- 当 type 为 1 时：显示二维码并提示扫码 -->
      <div v-if="clientConfig.type === 1" class="qrcode-container">
        <p class="tip">请使用微信扫码完成验证</p>
        <img :src="qrcodeImage" alt="二维码" class="qrcode-image" />
      </div>

      <!-- 当 type 为 2 时：提示点击跳转到滑块页面 -->
      <div v-if="clientConfig.type === 2" class="link-container">
        <p class="tip">请点击下方链接打开验证页面</p>
        <p>
          <a :href="superviseUrl" target="_blank" class="link">点击跳转到滑块页面</a>
        </p>
      </div>

      <!-- 倒计时显示 -->
      <p v-if="countdown > 0" class="countdown">倒计时: {{ countdown }} 秒</p>
    </div>
  </Modal>
  </div>
</template>

<script>
import QRCode from 'qrcode';
import { Modal, Button } from 'view-design';
// import axios from 'axios';
// import axios from '../../public/static/lib/axios.min.js';

export default {
    props: {
        /**
           * clientConfig 配置信息，说明
           * { faceMinCount: 2, // 跳过次数
           *   skip: true, // 是否需要跳过
           *   blank: false, // 路由是否重新打开页面
           *   examRecordId: examRecordId, // 考试 ID
           *   coursewareCode: coursewareCode, // 课件 ID
           *   chapterId: this.playedVideoChapter.id, // 章节 ID
           *   faceSignInScene: FACE_SIGNIN_SCENE.BEFORE_EXAMINATION // 签到场景
           *   route: { name | path | params } // 路由信息
           * }
           */
        clientConfig: { type: Object },
    },
    name: 'SlideBeiJingVerify',
    components: {
        Modal,
        Button,
    },
    data() {
        return {
            showPopup: false,
            superviseUrl: '',
            qrcodeImage: '',
            heartTime: null,
            heartbeatInterval: null,
            checkInterval: null,
            countdown: 0,
            message: '',
            param:{},
        };
    },
    mounted() {
        this.param={ userId:this.clientConfig.userId, cwCode:this.clientConfig.coursewareCode, type:this.clientConfig.type, studyToken:'', pointCode:'', };
        // console.log('this.clientConfig', this.clientConfig);
        // console.log('this.param', this.param);
        this.initLearning();
    },
    methods: {
        // 初始化学习
        async initLearning() {
            try {
                const response = await this.requestinitStudy(); // 请求地址A
                if (response.code === 0) {
                    this.message = response.message;
                    Utils.warning('初始化学习错误', this.message, 3600);
                    this.showConfirm('初始化学习错误', this.message);
                    this.$emit('on-pause');
                }
                if (response.heartTime) {
                    this.heartTime = response.heartTime;
                    this.startHeartbeatTask();
                }
                if (response.SuperviseUrl) {
                    this.superviseUrl = response.SuperviseUrl;
                    this.handleSuperviseUrl();
                }
            } catch (error) {
                console.error('初始化学习失败:', error);
                Utils.warning('初始化学习失败', error);
                this.$emit('on-pause');
            }
        },

        // 开始心跳任务
        startHeartbeatTask() {
            if (this.heartbeatInterval) {
                clearInterval(this.heartbeatInterval);
            }
            this.heartbeatInterval = setInterval(() => {
                this.sendHeartbeat();
            }, this.heartTime * 1000);
        },

        // 发送心跳验证
        async sendHeartbeat() {
            try {
                const response = await this.checkHeartBeat(); // 请求心跳B地址
                if (response.code === 2 && response.SuperviseUrl) {
                    this.superviseUrl = response.SuperviseUrl;
                    this.handleSuperviseUrl();
                }
            } catch (error) {
                console.error('心跳验证失败:', error);
                Utils.warning('心跳验证失败', error);
                this.$emit('on-pause');
            }
        },

        // 处理 SuperviseUrl
        async handleSuperviseUrl() {
            this.qrcodeImage = await QRCode.toDataURL(this.superviseUrl); // 将链接生成二维码
            this.showPopup = true;
            this.$emit('on-pause');
            // 开启每5秒验证C接口的任务
            if (this.checkInterval) {
                clearInterval(this.checkInterval);
            }
            this.checkInterval = setInterval(() => {
                this.checkStatus();
            }, 5000);
        },

        // 验证C接口状态
        async checkStatus() {
            try {
                const response = await this.getSuperviseResult(); // 请求C接口
                if (response.code === 0) {
                    this.message = response.message;
                    Utils.warning('请求结果失败', this.message, 3600);
                    // 关闭弹窗并重启初始化
                    this.closePopup();
                    this.initLearning();
                } else if (response.checkStatus === 0) {
                    // 展示倒计时
                    const endTime = new Date(response.checkEndTime).getTime();
                    const nowTime = new Date(response.nowTime).getTime();
                    this.countdown = Math.ceil((endTime - nowTime) / 1000);
                    if (this.countdown <= 0) {
                        this.countdown = 0;
                        // 关闭弹窗并重启初始化
                        this.closePopup();
                        this.initLearning();
                    }
                } else if (response.checkStatus === 1) {
                    // 关闭弹窗并重启心跳任务
                    this.closePopup();
                    this.startHeartbeatTask();
                    this.$emit('on-complete');
                }
            } catch (error) {
                console.error('请求结果失败:', error);
                Utils.warning('请求结果失败', error);
                this.$emit('on-pause');
            }
        },

        // 关闭弹窗
        closePopup() {
            this.showPopup = false;
            this.superviseUrl = '';
            this.qrcodeImage = '';
            this.countdown = 0;
            if (this.checkInterval) {
                clearInterval(this.checkInterval);
            }
        },
        // 模拟请求地址A
        requestinitStudy() {
            let _this = this;
            return new Promise((resolve, reject) => {
                axios.post(this.clientConfig.initStudy, this.param).then((response) => {
                    const resdata = response.data;
                    if (resdata.success) {
                        if (resdata.data.code===0) {
                            Utils.warning('请求初始化失败', resdata.data.message || resdata.message, 3600);
                            _this.showConfirm('请求初始化失败', resdata.data.message || resdata.message);
                            this.$emit('on-pause');
                        }
                        if (resdata.data.pointCode) {
                            this.param.pointCode=resdata.data.pointCode;
                        }
                        resolve({
                            success: resdata.success,
                            message: resdata.data.message || resdata.message,
                            code: resdata.data.code,
                            heartTime: resdata.data.heartTime || 180,
                            SuperviseUrl: resdata.data.SuperviseUrl || '',
                            pointCode: resdata.data.pointCode || '',
                        });
                    } else {
                        Utils.warning('请求初始化失败',  resdata.message, 3600);
                        _this.showConfirm('请求初始化失败', resdata.message);
                        this.$emit('on-pause');
                    }
                }).catch((error) => {
                    console.error('请求初始化失败:', error);
                    Utils.warning('请求初始化失败', error, 3600);
                    this.$emit('on-pause');
                    reject(error);
                });
            });
        },

        // 模拟请求心跳B地址
        checkHeartBeat() {
            let _this = this;
            return new Promise((resolve, reject) => {
                axios.post(this.clientConfig.checkHeartBeat, this.param).then((response) => {
                    const resdata = response.data;
                    if (resdata.success) {
                        const message = resdata.data && resdata.data.message ? resdata.data.message : resdata.message;
                        if (resdata.data.code===0) {
                            // 提前获取消息内容
                            if (message.indexOf('该课程已完成')>-1) {
                                Utils.success('该课程已完成', message, 3600);
                                _this.showConfirm('该课程已完成，请在课程列表刷新查看', message);
                                this.$emit('on-pause');
                            } else {
                                Utils.warning('请求心跳失败,请重新打开课程学习', message, 3600);
                                _this.showConfirm('请求心跳失败,请重新打开课程学习', message);
                                this.$emit('on-pause');
                            }
                        }
                        if (resdata.data.pointCode) {
                            this.param.pointCode=resdata.data.pointCode;
                        }
                        resolve({
                            success: resdata.success,
                            message: message,
                            code: resdata.data.code,
                            SuperviseUrl: resdata.data.SuperviseUrl || '',
                            pointCode: resdata.data.pointCode || '',
                        });
                    } else {
                        Utils.warning('请求心跳失败',  resdata.message, 3600);
                        _this.showConfirm('请求心跳失败', resdata.message);
                        this.$emit('on-pause');
                    }
                }).catch((error) => {
                    console.error('请求心跳失败:', error);
                    Utils.warning('请求心跳失败', error, 3600);
                    this.$emit('on-pause');
                    reject(error);
                });
            });
        },

        // 模拟请求C获取结果接口
        getSuperviseResult() {
            let _this = this;
            return new Promise((resolve, reject) => {
                axios.post(this.clientConfig.getSuperviseResult, this.param).then((response) => {
                    const resdata = response.data;
                    if (resdata.success) {
                        if (resdata.data.code===0) {
                            Utils.warning('获取结果接口错误', resdata.data.message || resdata.message, 3600);
                            _this.showConfirm('获取结果接口错误', resdata.data.message || resdata.message);
                            this.$emit('on-pause');
                        }
                        resolve({
                            success: resdata.success,
                            message: resdata.data.message || resdata.message,
                            code: resdata.data.code,
                            checkStatus: resdata.data.datajson.checkStatus || 0,
                            checkEndTime: resdata.data.datajson.checkEndTime,
                            nowTime: resdata.data.datajson.nowTime,
                        });
                    } else {
                        Utils.warning('获取结果接口错误',  resdata.message, 3600);
                        _this.showConfirm('获取结果接口错误', resdata.message);
                        this.$emit('on-pause');
                    }
                }).catch((error) => {
                    console.error('获取结果失败:', error);
                    Utils.warning('获取结果失败', error, 3600);
                    this.$emit('on-pause');
                    reject(error);
                });
            });
        },
        showConfirm(title, msg) {
            this.$Modal.info({
                title: title,
                content: '<p>'+msg+'服务热线：400-0090-211</p>',
                onOk: () => {
                    // window.close();
                    window.location.reload();
                    // window.location.href = '/'; // 跳转到首页或其他页面
                // 执行删除操作的代码
                // this.$Message.info('已确认删除');
                },
            // onCancel: () => {
            //     // this.$Message.info('取消删除');
            // }
            });
        },
    },
    beforeDestroy() {
        if (this.heartbeatInterval) {
            clearInterval(this.heartbeatInterval);
        }
        if (this.checkInterval) {
            clearInterval(this.checkInterval);
        }
    },
};
</script>

<style scoped>
  .message {
    margin-top: 20px;
    padding: 10px;
    background-color: #f8f8f9;
    border: 1px solid #e8eaec;
    border-radius: 4px;
  }
  .modal-content {
  text-align: center; /* 内容居中 */
}

.qrcode-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.tip {
  margin-bottom: 10px;
  font-size: 14px;
  color: #333;
}

.qrcode-image {
  width: 150px;
  height: 150px;
  margin: 0 auto; /* 图片居中 */
}

.link-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.link {
  color: #1890ff;
  text-decoration: underline;
}

.countdown {
  margin-top: 10px;
  font-size: 14px;
  color: #666;
}
</style>
